import { render, staticRenderFns } from "./FirmaDoc.vue?vue&type=template&id=4940a1ca&"
import script from "./FirmaDoc.vue?vue&type=script&lang=js&"
export * from "./FirmaDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4940a1ca')) {
      api.createRecord('4940a1ca', component.options)
    } else {
      api.reload('4940a1ca', component.options)
    }
    module.hot.accept("./FirmaDoc.vue?vue&type=template&id=4940a1ca&", function () {
      api.rerender('4940a1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/FirmaDocumentos/FirmaDoc.vue"
export default component.exports